import React, { useEffect, useState, useContext } from "react";
import RenovationSchedule from "../../../components/Schedules/Others/RenovationSchedule";
import { AuthContext } from "../../../contexts/AuthContext";
import { useErrorDialog } from "../../../contexts/ErrorDialogContext";
import { useSuccessDialog } from "../../../contexts/SuccessDialogContext";
import ComponentLoading from "../../../components/App/ComponentLoading";
import { handleScheduleDeletion } from "../utils/handleScheduleDeletion";
import { useAccessControl } from "../../../utils/hooks/useAccessControl";
import { PL_SCHEDULES } from "../../../utils/data/controlData";

const RenovationSchedulePage = ({ company, scheduleId }) => {
  const { updatePLSchedule, getScheduleData, deleteScheduleByScheduleType } =
    useContext(AuthContext);
  const [saveTrigger, setSaveTrigger] = useState(false);
  const [schedule, setSchedule] = useState({});
  const [scheduleDetails, setScheduleDetails] = useState({});

  const { canEdit: canEditPLSchedule } = useAccessControl(PL_SCHEDULES);

  const [loading, setLoading] = useState(true);

  const handleError = useErrorDialog();
  const handleSuccess = useSuccessDialog();

  const saveSchedule = async (schedule, scheduleDetails) => {
    if (!company || !scheduleId) {
      handleError("Unexpected error happens. Please try again later.");
      return;
    }

    const updatedSchedule = {
      sch_id: scheduleId,
      scheduleType: "Renovation",
      scheduleTitle: schedule.name,
      mode: scheduleDetails.mode,
      isSdg: scheduleDetails.isSdg,
      rennovationRows: scheduleDetails.rennovationRows,
      firstTableRows: scheduleDetails.firstTableRows,
      secondTableRows: scheduleDetails.secondTableRows,
      notes: schedule.notes,
      reviewNotes: schedule.reviewNotes,
      totalAdjustment: scheduleDetails.totalAdjustment,
      doc: scheduleDetails.doc,
    };

    setLoading(true);
    const response = await updatePLSchedule(updatedSchedule);
    setLoading(false);

    if (response) {
      handleSuccess("The schedule has been saved successfully.");
      setSaveTrigger((prev) => !prev);
    } else {
      handleError(
        "There was a problem saving the schedule. Please contact support if the issue persists."
      );
    }
  };

  const deleteSchedule = async () => {
    await handleScheduleDeletion({
      scheduleId,
      deleteFn: deleteScheduleByScheduleType,
      handleSuccess,
      handleError,
      setLoading,
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      if (!company || !scheduleId) {
        handleError(
          "We encountered an issue while fetching the data. Please refresh the page or try again shortly."
        );
        return;
      }
      //API call here
      const response = await getScheduleData(scheduleId, 'Renovation');

      const scheduleData = response.schedule;
      //init
      if (scheduleData) {
        setSchedule({
          id: scheduleData.id,
          type: "Renovation",
          scheduleNo: scheduleData.scheduleNo,
          name: "Renovation and Refurbishment Deductions Under S14N",
          notes: scheduleData.notes,
          reviewNotes: scheduleData.reviewNotes,
        });

        setScheduleDetails({
          mode: scheduleData.mode,
          isSdg: scheduleData.isSdg,
          dataRows: {
            rennovationRows: scheduleData.rennovationRows,
            first: scheduleData.firstTableRows,
            second: scheduleData.secondTableRows,
          },
        });
      }

      setLoading(false);
    };

    fetchData();
  }, [saveTrigger, scheduleId, company.uen, getScheduleData, updatePLSchedule]);

  return (
    <>
      {loading ? (
        <ComponentLoading />
      ) : (
        <RenovationSchedule
          company={company}
          schedule={schedule}
          scheduleDetails={scheduleDetails}
          saveSchedule={saveSchedule}
          deleteSchedule={deleteSchedule}
          canEditSchedule={canEditPLSchedule}
        />
      )}
    </>
  );
};

export default RenovationSchedulePage;
